import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import generalActions from 'redux/actions/generalActions'
import Modalizer from 'components/modalizer/modalizer'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

const PlaygroundSampleModal = props => (
	<Modalizer width='552px' height='502px' closeAction={() => props.actions.closeModal(props.modalName)}>
		Component to be modalized...
	</Modalizer>
)

PlaygroundSampleModal.propTypes = {
	modalName: PropTypes.string,
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(PlaygroundSampleModal)
